// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

import type { Locale } from './en'

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.it = {
  general: {
    forms: {
      response: {
        error: {
          text: 'Controlla il tuo inserimento e riprova. I seguenti campi contengono errori: ',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Grazie per il tuo messaggio, ${data.firstname}. Ti contatteremo il prima possibile riguardo a "${data.subject}".`,
        },
      },
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Maggiori informazioni su ${data.productTitle}`,
        link: (data: { linkTitle: string }) =>
          `Maggiori informazioni su ${data.linkTitle}`,
      },
    },
  },
  accessibility: {
    close_notification: 'Chiudi notifica',
  },
  products: {
    product: {
      options: {
        more_single: 'Altro',
        more_plural: 'Altri',
      },
      option_name: {
        pack: 'Confezione',
        pack_number: {
          '1_html': 'Prodotto singolo',
          '3_html': '3 pezzi',
          '6_html': '6 pezzi',
          '12_html': '12 pezzi',
          '24_html': '24 pezzi',
          default_html: (data: { count: string }) => `${data.count} pezzi`,
        },
        discount_html: (data: { percent: string }) =>
          `Risparmia ${data.percent}%`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} pz`,
      },
      add_to_cart: 'Aggiungi al carrello',
      add_to_cart_sm: 'Aggiungi al carrello',
      add_to_cart_title: (data: { productTitle: string }) =>
        `Aggiungi ${data.productTitle} al carrello`,
      new: 'Nuovo',
      quantity: {
        input_label: (data: { product: string }) =>
          `Quantità di ${data.product}`,
        increase: (data: { product: string }) =>
          `Aumenta la quantità per ${data.product}`,
        decrease: (data: { product: string }) =>
          `Diminuisci la quantità per ${data.product}`,
      },
      price: {
        from: 'Da',
      },
      sold_out: 'Esaurito',
      diet_disclaimer:
        'Secondo la ricetta, possibile contaminazione incrociata.',
      sugar_disclaimer: 'Contiene zuccheri naturali.',
      salt_disclaimer: 'Contiene sale naturale.',
      nutrient_data: {
        title: 'Valori nutrizionali',
        'title-average': 'Valori nutrizionali medi',
        'per-unit': '100g',
        caloricvalue: 'Valore energetico (in kJ/kcal)',
        fat: 'Grassi',
        fat_of_which_saturates: 'di cui acidi grassi saturi',
        fat_of_which_mono_unsaturates: 'di cui acidi grassi monoinsaturi',
        carbohydrate: 'Carboidrati',
        carbohydrate_of_which_sugars: 'di cui zuccheri',
        carbohydrate_of_which_polyols: 'di cui polioli',
        carbohydrate_of_which_starch: 'di cui amido',
        fibre: 'Fibre',
        protein: 'Proteine',
        salt: 'Sale',
        vitamin_e: 'Vitamina E',
        potassium: 'Potassio',
        chloride: 'Cloruro',
        calcium: 'Calcio',
        phosphorus: 'Fosforo',
        omega_3_fatty_acids: 'Acidi grassi Omega 3',
        magnesium: 'Magnesio',
        iron: 'Ferro',
        zinc: 'Zinco',
        copper: 'Rame',
        manganese: 'Manganese',
        fluoride: 'Fluoruro',
        selenium: 'Selenio',
        chromium: 'Cromo',
        molybdenum: 'Molibdeno',
        iodine: 'Iodio',
        fat_of_which_polyunsaturates: 'di cui acidi grassi polinsaturi',
        vitamin_a: 'Vitamina A',
        vitamin_d: 'Vitamina D',
        vitamin_k: 'Vitamina K',
        vitamin_c: 'Vitamina C',
        thiamin: 'Tiamina',
        riboflavin: 'Riboflavina',
        niacin: 'Niacina',
        vitamin_b6: 'Vitamina B6',
        folic_acid: 'Acido folico',
        vitamin_b12: 'Vitamina B12',
        biotin: 'Biotina',
        pantothenic_acid: 'Acido pantotenico',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Dieta',
        'gluten-free': 'senza glutine',
        'lactose-free': 'senza lattosio',
        vegan: 'vegano',
        vegetarian: 'vegetariano',
        'no-added-sugar': 'senza zuccheri aggiunti',
        'no-added-salt': 'senza sale aggiunto',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) =>
        `Filtra per ${data.filter}`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `Rimuovi ${data.title}`,
      presents: {
        button_label: 'Scegli regalo',
      },
    },
    'sb-popup-variant-overlay': {
      select_option: "Seleziona un'opzione",
      select_option_zustand: 'Chicco intero o macinato?',
      select_option_inhalt: 'Quanto ne vuoi?',
      select_option_packung: 'Quante confezioni?',
      title: '',
    },
  },
  localization: {
    international: 'Internazionale',
    country_section: 'Paese di consegna',
    language_section: 'Lingua',
    country_section_desc: 'Seleziona il paese dove effettuare la consegna.',
    language_section_desc: 'Seleziona la tua lingua preferita.',
    redirect_title: 'Reindirizzamento',
    redirect_message:
      'Sarai reindirizzato alla versione linguistica %selection% a breve.',
    non_order_options: 'Selezione senza possibilità di ordinare',
  },
  'customer-favorites': {
    'add-to-favorites': 'Aggiungi ai preferiti',
    'remove-from-favorites': 'Rimuovi dai preferiti',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Risparmia ${data.value}`,
  },
} satisfies Locale
